<!-- 
	This is the user profile page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <!-- Header Background Image -->
    <div
      class="profile-nav-bg"
      style="background-image: url('images/bg-profile.jpg')"
    ></div>
    <!-- / Header Background Image -->

    <!-- User Profile Card -->
    <a-card
      :bordered="false"
      class="card-profile-head"
      :bodyStyle="{ padding: 0 }"
    >
    </a-card>
    <!-- User Profile Card -->

    <a-row type="flex" :gutter="24">
      <!-- Platform Settings Column -->
      <a-col :span="24" :md="4" class="mb-24"> </a-col>
      <!-- / Platform Settings Column -->

      <!-- Profile Information Column -->
      <a-col :span="24" :md="16" class="mb-24">
        <!-- Profile Information Card -->
        <CardProfileInformation
		:student='student'></CardProfileInformation>
        <!-- / Profile Information Card -->
      </a-col>
      <!-- / Profile Information Column -->

      <!-- Conversations Column -->
      <a-col :span="24" :md="4" class="mb-24"> </a-col>
      <!-- / Conversations Column -->
    </a-row>
  </div>
</template>

<script>

import CardProfileInformation from "../components/forms/EditFees.vue";
export default {
  components: {
    CardProfileInformation,
  },
  data() {
    return {
		// student to be edited
		student:"hello",
      // Active button for the "User Profile" card's radio button group.
      profileHeaderBtns: "overview",
    };
  },
  methods: {  
  },
};
</script>

<style lang="scss"></style>
